import { CategoryInterface } from '@core/models';

export interface CategoryDisplay {
  category: CategoryInterface;
  status: 'current' | 'added' | 'deleted';
}

export function compareCategoriesWithPrevious(
  currentCategories: CategoryInterface[] | undefined,
  previousCategories: CategoryInterface[] | undefined,
): CategoryDisplay[] {
  if (!currentCategories) return [];

  if (!previousCategories) {
    return currentCategories.map((category) => ({
      category,
      status: 'current',
    }));
  }

  const previousIds = new Set(previousCategories.map((category) => category.id));
  const currentIds = new Set(currentCategories.map((category) => category.id));

  const result: CategoryDisplay[] = [
    ...currentCategories.map(
      (category): CategoryDisplay => ({
        category,
        status: previousIds.has(category.id) ? 'current' : 'added',
      }),
    ),
    ...previousCategories
      .filter((prevCategory) => !currentIds.has(prevCategory.id))
      .map(
        (category): CategoryDisplay => ({
          category,
          status: 'deleted',
        }),
      ),
  ];

  return result;
}
